import React, { useState, useEffect } from "react";
import { Dimensions, Pressable, Image as RNImage } from "react-native";
import { Image } from "expo-image";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import DModal from "./DModal";
import { TouchableOpacity } from "react-native-gesture-handler";
import { View } from "./Themed";
import { IconButton } from "react-native-paper";

const Zoom = React.memo((op) => {
    const [ratio, setRatio] = useState(1);
    const screenWidth = Dimensions.get("window").width;

    // Get actual image dimensions
    useEffect(() => {
        if (op.source?.uri) {
            RNImage.getSize(op.source.uri, (w, h) => {
                setRatio(w / h); // width ÷ height
            });
        }
    }, [op.source]);

    return (
        <DModal
            isVisible={op.show}
            onBackdropPress={() => op.close()}
            style={{
                margin: 0,
                position: "absolute",
                top: 0,
                backgroundColor: "rgba(0,0,0,0.95)",
                left: 0,
                alignItems: "center",
                justifyConent: "center",
                width: "100%",
                height: "100%",
            }}
            animationIn="fadeIn"
            animationOut="fadeOut"
        >
            <Pressable style={{
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                height: "100%",
            }}
                onPress={() => op.close()}
            >
                <IconButton style={{ zIndex: 9000, position: "absolute", top: 0, right: 5 }} iconColor="red" icon={"close"} size={24} onPress={() => op.close()} />
                <TransformWrapper>
                    <TransformComponent
                        wrapperStyle={{
                            width: Dimensions.get("window").width,
                            height: Dimensions.get("window").height,
                        }}
                        contentStyle={{
                            width: Dimensions.get("window").width,
                            height: Dimensions.get("window").height,
                        }}
                    >
                        <Image
                            source={op.source}
                            contentFit="contain"
                            style={{
                                width: screenWidth,   // full width
                                aspectRatio: ratio,   // auto height based on actual image ratio
                            }}
                        />
                    </TransformComponent>
                </TransformWrapper>
            </Pressable>
        </DModal >
    );
});

export default Zoom;